import { Stack, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { FormLabel } from 'src/components/Forms/FormLabel/form-label';

const PILL_ROW_GAP = 0.75;
// sibling rows are taller than their label, so centring leaves ~6px above it; a pill line is
// exactly label-height and has to add that space itself to keep the panel's vertical rhythm
const PILL_ROW_TOP_SPACING = 0.75;

interface PillRowProps {
  label: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * One wrapping line for a side-panel property whose value is a list of pills: the
 * label is just the first item, so pills start beside it and overflow wraps beneath it.
 */
export const PillRow = ({ label, children, sx }: PillRowProps) => (
  <Stack
    direction="row"
    flexWrap="wrap"
    alignItems="center"
    gap={PILL_ROW_GAP}
    rowGap={1}
    px={2}
    mt={PILL_ROW_TOP_SPACING}
    sx={sx}
  >
    <FormLabel label={label} />
    {children}
  </Stack>
);
